import Vue from 'vue'
import App from './app'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './helpers/router'
import 'vue-code-highlight/themes/prism-twilight.css'
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import './styles/app.css'

import lang from './helpers/lang'
import config from './helpers/config'
import colors from './helpers/colors'

import BcqUi from './lib.js'

import AllSectionBlocks from './components/all-section-blocks'
import AppMain from './components/app-main'
import AppFooter from './components/app-footer'
import Navigation from './components/navigation'
import PageMeta from './components/page-meta'
import Colors from './components/colors'
import Elevation from './components/elevation'
import Flags from './components/flags'
import HThree from './components/h-three'
import Paragraph from './components/paragraph'
import AppColorSwitcher from './components/app-color-switcher'
import AppToolbarActions from './components/app-toolbar-actions'
import CodeChunk from './components/code-chunk'
import TestToolbar from './components/test-toolbar'
import Icons from './components/icons'
import CodeViewer from './components/code-viewer'
import SectionBlocks from './components/section-blocks'
import MdSection from './components/md-section'
import SearchForm from './components/search-form'
import BcqBundler from './components/bcq-bundler'
import BrowseCode from './components/browse-code'
import DeviceEmulator from './components/device-emulator'
import PrevNext from './components/prev-next'
import Badges from './components/badges'
import ThemeColorsDisplay from './components/theme-colors-display'
import DeploymentChecklist from './components/deployment-checklist'

import methods from './mixins/methods'
import ThemeColorsCreator from './components/theme-colors-creator'

Vue.component('recycle-scroller', RecycleScroller)
Vue.component('all-section-blocks', AllSectionBlocks)
Vue.component('app-main', AppMain)
Vue.component('app-footer', AppFooter)
Vue.component('navigation', Navigation)
Vue.component('page-meta', PageMeta)
Vue.component('colors', Colors)
Vue.component('elevation', Elevation)
Vue.component('flags', Flags)
Vue.component('h-three', HThree)
Vue.component('paragraph', Paragraph)
Vue.component('app-color-switcher', AppColorSwitcher)
Vue.component('app-toolbar-actions', AppToolbarActions)
Vue.component('code-chunk', CodeChunk)
Vue.component('test-toolbar', TestToolbar)
Vue.component('icons', Icons)
Vue.component('code-viewer', CodeViewer)
Vue.component('section-blocks', SectionBlocks)
Vue.component('md-section', MdSection)
Vue.component('search-form', SearchForm)
Vue.component('bcq-bundler', BcqBundler)
Vue.component('browse-code', BrowseCode)
Vue.component('device-emulator', DeviceEmulator)
Vue.component('prev-next', PrevNext)
Vue.component('badges', Badges)
Vue.component('theme-colors-display', ThemeColorsDisplay)
Vue.component('theme-colors-creator', ThemeColorsCreator)
Vue.component('deployment-checklist', DeploymentChecklist)

Vue.config.productionTip = false

Vue.use(BcqUi)
Vue.use(VueAxios, axios)

Vue.prototype.$lang = lang
Vue.prototype.$config = config
Vue.prototype.$colors = colors

/* eslint-disable no-new */
new Vue({
  router,
  el: '#app',
  mixins: [
    methods
  ],
  components: {
    App
  },
  template: '<App/>',
  data () {
    return {
      colors,
      config,
      ajax: false,
      dark: this.getLocalSettings() ? this.getLocalSettings().dark : this.$config.dark,
      nightShift: this.getLocalSettings() ? this.getLocalSettings().nightShift : this.$config.nightShift,
      date: new Date(),
      cookieConsent: false,
      deviceEmulator: false,
      currentLocation: null,
      selectedSectionIndex: null,
      search: {
        q: ''
      },
      navbar: {
        collapsed: true,
        floating: false,
        temporary: false,
        right: false
      },
      codeViewer: {
        script: null,
        template: null,
        data: null,
        visible: false,
        fullScreen: false,
        tabDense: false,
        modal: true,
        persistent: true,
        paddingOff: true,
        width: '100%',
        minWidth: '80%',
        tabHeight: '60vh',
        title: this.$lang.code,
        icon: 'code-tags'
      },
      fab: {
        visible: false,
        offset: 200
      }
    }
  },
  watch: {
    '$route.path' () {
      this.scrollToTop()
      this.codeViewer.visible = false
      if (this.navbar.temporary) {
        this.navbar.collapsed = true
      }
      this.currentLocation = location.href
    },
    'nightShift' () {
      this.storeLocalSetting('nightShift', this.nightShift)
    },
    '$dark' () {
      this.$root.$emit('theme-change', this.$dark)
      this.storeLocalSetting('dark', this.$dark)
    }
  },
  created () {
    this.onCreated()
    this.currentLocation = location.href
  },
  methods: {
    onCreated () {
      this.addAxiosInterceptors()
      this.bind()
    },
    bind () {
      window.addEventListener('scroll', () => {
        this.fab.visible = this.getScroll()[1] >= this.fab.offset
      })
    },
    sleep (timeout = 0) {
      return new Promise((resolve) => setTimeout(resolve, timeout))
    },
    addAxiosInterceptors () {
      const interceptors = this.$http.interceptors
      interceptors.request.use(config => {
        this.ajax = true
        return config
      }, error => {
        this.ajax = false
        return Promise.reject(error)
      })
      interceptors.response.use(async response => {
        const throttle = localStorage.getItem('throttle') || 0
        await this.sleep(throttle)
        this.ajax = false
        return response
      }, error => {
        this.ajax = false
        return Promise.reject(error)
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js